//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Helper
import { isPill, isPlusUni } from '../../../interface_helpers';
import { getComponentByDeviceMode } from '../../local/core/local_action_components_helpers';
//Types
import type { WebHooksParams } from 'src/types/requests/settings/webhooks';
import type { Device } from 'src/types/Device';

export const checkInputsMoreThanChannels = (device: Device, deviceSetting: any): boolean => {
	const inputs = Object.keys(deviceSetting).filter((i) => /^input:\d$/.test(i));
	return !isPlusUni(device?.type) && !isPill(device?.type) && device.channels_count < inputs.length;
};

export const getComponents = (device: Device, deviceSetting: any) => {
	const options = [];
	const inputs = Object.keys(deviceSetting)
		.filter((i) => /^input:\d$/.test(i))
		.sort();
	const $format = get(format);
	for (let i = 0; i < inputs.length; ++i) {
		const input = deviceSetting[inputs[i]];
		// Show only inputs relevant to the current channel if inputs > channels
		if (device.channels_count !== inputs.length / 2 || i >> 1 === device.channel) {
			options.push({
				title:
					input.name ||
					$format(`webhooks_component_input`, {
						values: { input: input.id },
						default: `input (${input.id})`,
					}),
				type: 'input',
				component: `input:${input.id}`,
				inputType: input.type,
				cid: input.id,
			});
		}
	}
	const { cid, mode, component } = getComponentByDeviceMode(device);
	options.unshift({
		title:
			deviceSetting[component]?.name ||
			(mode == 'switch'
				? $format(`webhooks_component_output`, {
						values: { output: cid },
						default: `Output (${cid})`,
					})
				: $format(`webhooks_component_${mode}`, { default: mode }) +
					(device.channels_count >= 2 ? ` (${cid})` : '')),
		type: mode,
		inputType: mode,
		component,
		cid,
	});
	return options;
};

export const getVoltmeterComponents = (device: Device, deviceSetting: any) => {
	const options = [];
	const voltmeters = Object.keys(deviceSetting)
		.filter((i) => i.startsWith('voltmeter:'))
		.sort();
	const $format = get(format);
	for (let i = 0; i < voltmeters.length; ++i) {
		const voltmeter = deviceSetting[voltmeters[i]];
		options.push({
			title:
				voltmeter.name ||
				$format(`webhooks_component_voltmeter`, {
					values: { id: voltmeter.id },
					default: `Voltmeter ({id})`,
				}),
			type: 'voltmeter',
			component: `voltmeter:${voltmeter.id}`,
			inputType: voltmeter.type,
			cid: voltmeter.id,
		});
	}
	const { cid, mode, component } = getComponentByDeviceMode(device);
	options.unshift({
		title:
			deviceSetting[component]?.name ||
			$format(`webhooks_component_${mode}`, { default: mode }) +
				(device.channels_count >= 2 ? ` (${cid})` : ''),
		type: 'cb',
		inputType: mode,
		component,
		cid,
	});
	return options;
};

export const getComponentInputType = (hook: WebHooksParams) => {
	let inputType = hook.inputType;
	if (hook.components) {
		const component = hook.components.filter((i) => i.type == 'input' && i.cid == hook.cid);
		if (component.length) inputType = component[0].inputType;
	}
	return inputType.replace('switch', 'toggle');
};
